/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { copilot } from '../models/copilot';
import type { parametersFilter } from '../models/parametersFilter';
import type { parametersFilterCount } from '../models/parametersFilterCount';
import type { parametersFilterDelete } from '../models/parametersFilterDelete';
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CopilotsService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * count copilots
   * Count copilots (with filtering, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any Count of copilot documents found. Wrapped in a JsonAPI root response with wrapped count result as data.
   * @throws ApiError
   */
  public getApiServiceorganizationsCopilotsCount(
    filter?: parametersFilterCount,
  ): CancelablePromise<{
    data?: {
      count?: number;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/copilots/count',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find one copilot
   * Find one copilot by its unique identifier.
   * @param identifier copilot unique identifier
   * @returns any One copilot document found. Wrapped in a JsonAPI root response with document as data.
   * @throws ApiError
   */
  public getApiServiceorganizationsCopilots(
    identifier: string,
  ): CancelablePromise<{
    data?: copilot;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/copilots/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * replace one copilot which exists or not
   * Replace one copilot which exists or not
   * @param identifier copilot unique identifier
   * @param requestBody
   * @returns any copilot replaced. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public putApiServiceorganizationsCopilots(
    identifier: string,
    requestBody?: copilot,
  ): CancelablePromise<{
    data?: copilot;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/serviceorganizations/copilots/{identifier}',
      path: {
        'identifier': identifier,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update one existing copilot
   * Partially update one existing copilot
   * @param identifier copilot unique identifier
   * @param requestBody
   * @returns any updated copilot. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServiceorganizationsCopilots(
    identifier: string,
    requestBody?: copilot,
  ): CancelablePromise<{
    data?: copilot;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceorganizations/copilots/{identifier}',
      path: {
        'identifier': identifier,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * delete one copilot
   * Delete one copilot
   * @param identifier copilot unique identifier
   * @returns any delete status copilots. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public deleteApiServiceorganizationsCopilots(
    identifier: string,
  ): CancelablePromise<{
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/serviceorganizations/copilots/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find many copilots
   * Find many copilots (with filtering, projection, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * - To only return specific fields, use the projection query parameter. Usage is as follows: filter[fields][fieldName1]=true&filter[fields][fieldName2]=true.
   * @param filter
   * @returns any One or many copilot documents found. Wrapped in a JsonAPI root response with collection of documents as data.
   * @throws ApiError
   */
  public getApiServiceorganizationsCopilots1(
    filter?: parametersFilter,
  ): CancelablePromise<{
    data?: Array<copilot>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/copilots',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * create one or multiple copilots
   * Create one or multiple copilots
   * @param requestBody
   * @returns any One or many copilot documents created. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public postApiServiceorganizationsCopilots(
    requestBody?: (copilot | Array<copilot>),
  ): CancelablePromise<{
    data?: (copilot | Array<copilot>);
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/copilots',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * replace many copilots which exists or not
   * Replace many copilots which exists or not
   * @param requestBody
   * @returns any copilots replaced. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public putApiServiceorganizationsCopilots1(
    requestBody?: Array<copilot>,
  ): CancelablePromise<{
    data?: Array<copilot>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/serviceorganizations/copilots',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update many existing copilot
   * Partially update many existing copilot
   * @param requestBody
   * @returns any copilots updated. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServiceorganizationsCopilots1(
    requestBody?: Array<copilot>,
  ): CancelablePromise<{
    data?: Array<copilot>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceorganizations/copilots',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * delete many copilots
   * Delete many copilots using filtering. You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any delete status copilots. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public deleteApiServiceorganizationsCopilots1(
    filter?: parametersFilterDelete,
  ): CancelablePromise<{
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/serviceorganizations/copilots',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

}
